export default "/_nuxt/e977e011307b13ccf21a5a765f4bd245.svg";